import { AuthenticatedLayout } from "@components/layouts/AuthenticatedLayout";
import { UsersView } from "@containers/admin/UsersView";

const UsersPage = () => {
    return (
        <AuthenticatedLayout adminPage activeMenuItem="users">
            <UsersView maxW={400} />
        </AuthenticatedLayout>
    );
}

export default UsersPage;